import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { ProfileOrganization, ProfileDocumentModel } from 'Pages/profileOrganization'

export const profileOrganizationApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ProfileOrganization>>(
			urls.profileOrganization.index,
			{
				params,
			}
		)
		return res.data
	},
	getOne: async (id: string | number) => {
		const res = await axiosDS().get<ProfileOrganization>(`${urls.profileOrganization.index}/${id}`)
		return res.data
	},
	getAllDocument: async (partner_id: number) => {
		const res = await axiosDS().get<ResponseCatalog<ProfileDocumentModel>>(
			`${urls.profileOrganization.partner}/${partner_id}/document`
		)
		return res.data?.entries
	},
}
